
import { useState } from 'react';
import Button from '../base/Button';

export default function FeaturedGems() {
  const [activeCategory, setActiveCategory] = useState('all');

  const categories = [
    { id: 'all', name: '全部藏品' },
    { id: 'diamond', name: '钻石系列' },
    { id: 'ruby', name: '红宝石' },
    { id: 'sapphire', name: '蓝宝石' },
    { id: 'emerald', name: '祖母绿' }
  ];

  const gems = [
    {
      id: 1,
      name: '经典圆形钻石',
      category: 'diamond',
      carat: '2.5ct',
      clarity: 'VVS1',
      color: 'D',
      price: '¥128,000',
      image: 'https://public.readdy.ai/ai/img_res/c75cfc6fd66ade02a7c3ed1292685a18.jpg',
      badge: '艺术精品'
    },
    {
      id: 2,
      name: '缅甸鸽血红宝石',
      category: 'ruby',
      carat: '3.2ct',
      clarity: '微瑕',
      color: '鸽血红',
      price: '¥256,000',
      image: 'https://readdy.ai/api/search-image?query=Magnificent%20pigeon%20blood%20red%20ruby%20gemstone%20displayed%20in%20contemporary%20gallery%20setting%20with%20teal%20accent%20lighting%2C%20museum%20quality%20presentation%20on%20white%20pedestal%2C%20artistic%20jewelry%20photography&width=400&height=400&seq=gallery-ruby-1&orientation=squarish',
      badge: '馆藏珍品'
    },
    {
      id: 3,
      name: '克什米尔蓝宝石',
      category: 'sapphire',
      carat: '4.1ct',
      clarity: '净度佳',
      color: '矢车菊蓝',
      price: '¥198,000',
      image: 'https://readdy.ai/api/search-image?query=Stunning%20Kashmir%20blue%20sapphire%20in%20modern%20art%20gallery%20display%20with%20blue%20and%20pink%20ambient%20lighting%2C%20minimalist%20museum%20presentation%2C%20contemporary%20jewelry%20exhibition%20style&width=400&height=400&seq=gallery-sapphire-1&orientation=squarish',
      badge: '限量收藏'
    },
    {
      id: 4,
      name: '哥伦比亚祖母绿',
      category: 'emerald',
      carat: '2.8ct',
      clarity: '轻微内含物',
      color: '翠绿',
      price: '¥168,000',
      image: 'https://readdy.ai/api/search-image?query=Colombian%20emerald%20gemstone%20in%20contemporary%20gallery%20showcase%20with%20teal%20and%20pink%20lighting%20accents%2C%20modern%20museum%20display%20case%2C%20artistic%20jewelry%20presentation%20on%20white%20background&width=400&height=400&seq=gallery-emerald-1&orientation=squarish',
      badge: '新展品'
    },
    {
      id: 5,
      name: '心形粉钻',
      category: 'diamond',
      carat: '1.8ct',
      clarity: 'VS1',
      color: 'Fancy Pink',
      price: '¥298,000',
      image: 'https://readdy.ai/api/search-image?query=Heart%20shaped%20fancy%20pink%20diamond%20in%20modern%20art%20gallery%20setting%20with%20soft%20pink%20lighting%2C%20minimalist%20white%20display%20case%2C%20contemporary%20museum%20jewelry%20exhibition%20style&width=400&height=400&seq=gallery-diamond-2&orientation=squarish',
      badge: '艺术臻品'
    },
    {
      id: 6,
      name: '星光蓝宝石',
      category: 'sapphire',
      carat: '5.5ct',
      clarity: '星光效应',
      color: '深蓝',
      price: '¥88,000',
      image: 'https://readdy.ai/api/search-image?query=Star%20sapphire%20gemstone%20showing%20asterism%20effect%20in%20contemporary%20gallery%20display%20with%20blue%20and%20teal%20accent%20lighting%2C%20modern%20museum%20presentation%20style%2C%20artistic%20jewelry%20photography&width=400&height=400&seq=gallery-sapphire-2&orientation=squarish',
      badge: '特展作品'
    }
  ];

  const filteredGems = activeCategory === 'all' 
    ? gems 
    : gems.filter(gem => gem.category === activeCategory);

  return (
    <section className="py-24 bg-gradient-to-br from-pink-50 via-blue-50 to-teal-50" data-product-shop>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Gallery Header */}
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <div className="flex space-x-2 mb-6">
              <div className="w-12 h-1 bg-pink-400"></div>
              <div className="w-12 h-1 bg-blue-400"></div>
              <div className="w-12 h-1 bg-teal-400"></div>
            </div>
          </div>
          <h2 className="text-5xl font-light text-gray-800 mb-6 tracking-wide">FEATURED COLLECTION</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto font-light leading-relaxed">
            精心策展的珠宝艺术品，每一件都承载着独特的美学价值
          </p>
        </div>

        {/* Category Navigation */}
        <div className="flex justify-center mb-16">
          <div className="flex bg-white rounded-full p-2 shadow-lg border border-gray-100">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setActiveCategory(category.id)}
                className={`px-8 py-3 rounded-full font-light transition-all whitespace-nowrap cursor-pointer ${
                  activeCategory === category.id
                    ? 'bg-gradient-to-r from-pink-400 via-blue-400 to-teal-400 text-white shadow-md'
                    : 'text-gray-600 hover:text-gray-800 hover:bg-gray-50'
                }`}
              >
                {category.name}
              </button>
            ))}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
          {filteredGems.map((gem) => (
            <div key={gem.id} className="bg-white rounded-lg shadow-lg overflow-hidden hover:shadow-xl transition-all duration-500 group border border-gray-100">
              <div className="relative">
                <img
                  src={gem.image}
                  alt={gem.name}
                  className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-gradient-to-r from-pink-400 via-blue-400 to-teal-400 text-white px-4 py-2 rounded-full text-sm font-light shadow-lg">
                    {gem.badge}
                  </span>
                </div>
                <button className="absolute top-4 right-4 w-12 h-12 bg-white/90 rounded-full flex items-center justify-center text-gray-600 hover:text-pink-500 transition-colors cursor-pointer">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-heart-line"></i>
                  </div>
                </button>
                
                {/* Gallery Info Overlay */}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="grid grid-cols-3 gap-2 text-sm font-light">
                    <div>重量<br/><span className="font-normal">{gem.carat}</span></div>
                    <div>净度<br/><span className="font-normal">{gem.clarity}</span></div>
                    <div>颜色<br/><span className="font-normal">{gem.color}</span></div>
                  </div>
                </div>
              </div>
              
              <div className="p-6">
                <h3 className="text-xl font-light text-gray-800 mb-4 tracking-wide">{gem.name}</h3>
                
                <div className="flex items-center justify-between">
                  <span className="text-2xl font-light text-gray-800">{gem.price}</span>
                  <Button variant="primary" size="sm">
                    <span className="mr-1">查看详情</span>
                    <div className="w-4 h-4 flex items-center justify-center">
                      <i className="ri-arrow-right-line"></i>
                    </div>
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Gallery Footer */}
        <div className="text-center">
          <div className="inline-block mb-6">
            <div className="flex space-x-2">
              <div className="w-8 h-1 bg-pink-400"></div>
              <div className="w-8 h-1 bg-blue-400"></div>
              <div className="w-8 h-1 bg-teal-400"></div>
            </div>
          </div>
          <Button variant="outline" size="lg">
            <span className="mr-2">浏览完整收藏</span>
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-arrow-right-line"></i>
            </div>
          </Button>
        </div>
      </div>
    </section>
  );
}
